import { render, staticRenderFns } from "./GuideFood.vue?vue&type=template&id=4165dcd0"
import script from "./GuideFood.vue?vue&type=script&lang=js"
export * from "./GuideFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports